import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { updateItemRequestTrackingDetailsApi } from './updateItemRequestTrackingDetails.api'
import updateItemRequestTrackingDetailsInitialState from './updateItemRequestTrackingDetails.initialState'
import {
  UpdateItemRequestTrackingDetailsErrorResponse,
  UpdateItemRequestTrackingDetailsRequestPayload
} from './updateItemRequestTrackingDetails.types'

export const updateItemRequestTrackingDetails = createAsyncThunk(
  urls.offers.updateItemRequestTrackingDetails,
  async (payload: UpdateItemRequestTrackingDetailsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await updateItemRequestTrackingDetailsApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const updateItemRequestTrackingDetailsSlice = createSlice({
  name: urls.offers.updateItemRequestTrackingDetails,
  initialState: updateItemRequestTrackingDetailsInitialState,
  reducers: {
    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateItemRequestTrackingDetails.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(updateItemRequestTrackingDetails.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(updateItemRequestTrackingDetails.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as UpdateItemRequestTrackingDetailsErrorResponse
        state.success = null
      })
  }
})

export const { actions: updateItemRequestTrackingDetailsActions, reducer: updateItemRequestTrackingDetailsReducer } =
  updateItemRequestTrackingDetailsSlice
export default updateItemRequestTrackingDetailsSlice.reducer
